import { Module } from 'api/data.types'
import type { UserState } from 'utils/hooks/use-userInfo'
import { canNavigateBetweenEntitiesRegisteredToMe } from 'utils/permissions'

export const showRenderNotificationPreferences = (user: UserState) => {
  const hasSomeModule = [Module.INGLES, Module.LIVROS, Module.LER].some(
    module => user?.reader?.contentFilters?.includes(module)
  )

  return (
    (user?.teacher?.id &&
      !user?.isDisableWeeklyReadingReportNotification &&
      hasSomeModule) ??
    false
  )
}

export const shouldRenderMyAccount = (
  user: UserState,
  deleteAccountFlag?: boolean
) => {
  if (deleteAccountFlag) {
    return true
  }

  return Boolean(
    user?.teacher?.id && !user?.isDisableWeeklyReadingReportNotification
  )
}

export const shouldRenderSelectEntity = (user: UserState) => {
  if (user?.featureToggles?.newPermissionsManagement) {
    return Boolean(user?.teacher?.teacherEntities.length > 0)
  }

  return Boolean(
    canNavigateBetweenEntitiesRegisteredToMe(user?.teacher?.permissions)
  )
}
